import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {
        person: {}
        , organization: {}
        , response: {}
        , session: {}
    },
    status: 'idle', // idle loading success fail  
    additionalinfo: {},
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantGlobalSettingGuid}/{GlobalSettingName}/{GlobalSettingDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantGlobalSettingGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{GlobalSettingName}/{GlobalSettingDescription}/	
export const fetchGlobalSettings = createAsyncThunk('globalsetting/get', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.authToken + "/40CAB6FC-838F-4F55-97C3-EA70E31D5C86" + '/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const globalsettingSlice = createSlice({
    name: 'globalsettings',
    initialState,
    reducers: {
        globalsettingClear(state, action) {
            state.entities = initialState
            state.status = "idle"

        },
        globalsettingGetPrioritySesOrgPer(state, action) {
            const data = action.payload
            //console.log('global priority',data)
            const { SettingTypeKeyName } = data
            if (state.entities.session[SettingTypeKeyName]) {
                return (state.entities.session[SettingTypeKeyName])
            } else if (state.entities.person[SettingTypeKeyName]) {
                return (state.entities.person[SettingTypeKeyName])
            } else if (state.entities.organization[SettingTypeKeyName]) {
                return (state.entities.organization[SettingTypeKeyName])
            } else {
                return null
            }
        },
        globalsettingSet(state, action) {
            const data = action.payload
            const { SettingFamilyKeyName, Settings } = data
            console.log('setting set single', data)
            if (Array.isArray(Settings)) {
                // some settings are returned like OrganizationSettingValues:[{List:{SOME:SETTING,VALUE:OBJECT}}]
                const temp = Settings[0].List
                state.entities[SettingFamilyKeyName.toLowerCase()] = { ...state.entities[SettingFamilyKeyName.toLowerCase()], ...temp }
            } else {
                // else, most settings are returned like.. OrganizationSettingValues:{SOME:SETTING,VALUE:OBJECT}
                state.entities[SettingFamilyKeyName.toLowerCase()] = { ...state.entities[SettingFamilyKeyName.toLowerCase()], ...Settings }
            }

        },
        globalsettingSetAll(state, action) {
            const data = action.payload
            const { Settings } = data
            state.status = "loading"
   
            const tmp ={
                person: {}
                , organization: {}
                , response: {}
                , session: {}
            }
            if (Settings.OrganizationSettingValues) {
                tmp['organization'] = { ...state.entities['organization'], ...Settings.OrganizationSettingValues }
            }
            if (Settings.PersonSettingValues) {
                tmp['person'] = { ...state.entities['person'], ...Settings.PersonSettingValues }
            }
            if (Settings.SessionVariableValues) {
                tmp['session'] = { ...state.entities['session'], ...Settings.SessionVariableValues }
            }
            if (Settings.ResponseSettingValues) {
                tmp['response'] = { ...state.entities['response'], ...Settings.ResponseSettingValues }
            }
            state.entities=tmp
            state.status = "success"

        }


    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchGlobalSettings.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchGlobalSettings.fulfilled, (state, action) => {
                state.status = 'success'
                const loadesplitdData = action.payload.Info[0].ViewInstanceData[0].GlobalSettingVI.ProfileGlobalSettingFrame
                const { ProfileGlobalSettingLabels, ...secondary } = loadesplitdData

                state.entities = ProfileGlobalSettingLabels
                state.additionalinfo = secondary
            })
            .addCase(fetchGlobalSettings.rejected, (state, action) => {
                state.error = action.error.message

            })


    }
})

export const { globalsettingClear, globalsettingSet, globalsettingGetPrioritySesOrgPer,globalsettingSetAll } = globalsettingSlice.actions

export default globalsettingSlice.reducer

export const selectGlobalSettingEntities = (state) => state.globalsettings.entities

export const selectGlobalSettings = createSelector(selectGlobalSettingEntities, (entities) =>
    Object.values(entities)
)

export const selectGlobalSettingById = (state, GlobalSettingId) => {
    return selectGlobalSettingEntities(state)[GlobalSettingId]
}

export const selectSettingForTypeKeyName = createSelector(
    selectGlobalSettingEntities
    , (state, SettingTypeObject) => SettingTypeObject
    , (SettingList, SettingTypeObject) => {

        if (SettingList.session[SettingTypeObject.SettingTypeKeyName]) {
            return (SettingList.session[SettingTypeObject.SettingTypeKeyName])
        } else if (SettingList.person[SettingTypeObject.SettingTypeKeyName]) {
            return (SettingList.person[SettingTypeObject.SettingTypeKeyName])
        } else if (SettingList.organization[SettingTypeObject.SettingTypeKeyName]) {
            return (SettingList.organization[SettingTypeObject.SettingTypeKeyName])
        } else {
            return null
        }
    }

)
